<template>
  <div class="academy-container">
    <header class="academy-hd">
      <div
        class="academy-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="academy-hd-subTitle">狄诺尼学院</h4>
        <h2 class="academy-hd-title">帮助、学习与资格认证</h2>
        <h4 class="academy-hd-subTitle">
          与和值得信任的伙伴一起探索求知、学习实践和开展创新。
        </h4>
        <h4 class="academy-hd-subTitle">技术支持：4000-025-828</h4>
      </div>
    </header>
    <article class="academy-bd">
      <AnchorTabs ref="academyAnchorTabsRef" :tabList="tabLists" />
      <div id="AIRoad">
        <BaseAcademy
          type="AIRoad"
          helpDocumentUrl="/dnnweb/helpDocuments?soft=AIRoad&language=zh"
          :videoList="aiRoadVideoList"
          :skillList="aiRoadSkillList"
          :btnList="aiRoadBtnList"
          :categoryId="categoryIds.aiRoad"
        />
      </div>
      <div id="EICAD">
        <BaseAcademy
          type="EICAD"
          helpDocumentUrl="/dnnweb/helpDocuments?soft=EICAD&language=zh"
          :videoList="eiCadVideoList"
          :skillList="eiCadSkillList"
          :btnList="eiCadBtnList"
          :categoryId="categoryIds.eiCad"
        />
      </div>
      <div id="VRRoad">
        <BaseAcademy
          type="VRRoad"
          :videoList="vrRoadVideoList"
          :skillList="vrRoadSkillList"
          :btnList="vrRoadBtnList"
          :categoryId="categoryIds.vrRoad"
        />
      </div>
      <div id="Report3D">
        <BaseAcademy
          type="Report3D"
          helpDocumentUrl="/dnnweb/helpDocuments?soft=Report3D&language=zh"
          :videoList="report3DVideoList"
          :skillList="report3DSkillList"
          :btnList="report3DBtnList"
          :categoryId="categoryIds.report3D"
        />
      </div>
      <div id="EducCenter">
        <EduLearnCenter type="EducCenter" />
      </div>
    </article>
  </div>
</template>
<script>
import AnchorTabs from "@/components/AnchorTabs.vue";
import BaseAcademy from "./BaseAcademy.vue";
import EduLearnCenter from "./EduLearnCenter.vue";
import {
  aiRoadVideoList,
  eiCadVideoList,
  vrRoadVideoList,
  report3DVideoList,
} from "./data";

import { collegevideoListApi, infoManageApi } from "@/api/website";

export default {
  name: "Academy",
  components: { AnchorTabs, BaseAcademy, EduLearnCenter },
  data() {
    return {
      tabLists: [
        {
          name: "AIRoad",
          value: "AIRoad",
        },
        {
          name: "EICAD",
          value: "EICAD",
        },
        {
          name: "VRRoad",
          value: "VRRoad",
        },
        {
          name: "Report3D",
          value: "Report3D",
        },
        {
          name: "教育学习中心",
          value: "EducCenter",
        },
      ],
      // aiRoadVideoList: [...aiRoadVideoList],
      // eiCadVideoList: [...eiCadVideoList],
      // vrRoadVideoList: [...vrRoadVideoList],
      // report3DVideoList: [...report3DVideoList],
      aiRoadVideoList: [],
      eiCadVideoList: [],
      vrRoadVideoList: [],
      report3DVideoList: [],

      aiRoadSkillList: [],
      eiCadSkillList: [],
      vrRoadSkillList: [],
      report3DSkillList: [],

      aiRoadBtnList: [],
      eiCadBtnList: [],
      vrRoadBtnList: [],
      report3DBtnList: [],

      categoryIds: {
        aiRoad: "",
        eiCad: "",
        vrRoad: "",
        report3D: "",
      },
      anchor: "AIRoad",
    };
  },
  computed: {},
  created() {
    this.getVideoSkillAll();
  },
  mounted() {
    this.anchor = this.$route.query.anchor;
    if (this.anchor) {
      // 需等待数据调用完成，页面渲染完成
      setTimeout(() => {
        this.$refs.academyAnchorTabsRef.handleTabClick(this.anchor);
      }, 500);
    }
  },
  methods: {
    // 获取视频和技巧列表
    getVideoSkillAll() {
      collegevideoListApi().then((res) => {
        if (res.code == 200 && res.success) {
          console.log("collegevideoListApi", res);
          // 按 categoryName 匹配各产品分类，find 未匹配到时返回 undefined
          let airoadTemp = res.data.find(
            (item) => item.categoryName === "AIRoad",
          );
          let eicadTemp = res.data.find(
            (item) =>
              item.categoryName === "EACID" || item.categoryName === "EICAD",
          );
          let vrroadTemp = res.data.find(
            (item) => item.categoryName === "VRRoad",
          );
          let report3dTemp = res.data.find(
            (item) =>
              item.categoryName === "Repotr3D" ||
              item.categoryName === "Report3D",
          );

          this.categoryIds = {
            aiRoad: airoadTemp ? airoadTemp.id : "",
            eiCad: eicadTemp ? eicadTemp.id : "",
            vrRoad: vrroadTemp ? vrroadTemp.id : "",
            report3D: report3dTemp ? report3dTemp.id : "",
          };

          // 下载按钮：分类或 softwareList 不存在时用空数组，避免读取 undefined 属性
          this.aiRoadBtnList = (
            airoadTemp && airoadTemp.softwareList ? airoadTemp.softwareList : []
          ).map((item) => {
            // pathUrlIdList 可能为空，需先取首个附件再读 id 等字段
            const fileInfo =
              item.pathUrlIdList && item.pathUrlIdList.length > 0
                ? item.pathUrlIdList[0]
                : null;
            return {
              // btnName: item.name,
              btnName: "下载免费试用版",
              btnId: item.id,
              fileId: fileInfo ? fileInfo.id : "",
              fileTitle: fileInfo ? fileInfo.fileTitle : "",
              filePath: fileInfo ? fileInfo.path : "",
              fileSuffix: fileInfo ? fileInfo.suffix : "",
            };
          });
          this.eiCadBtnList = (
            eicadTemp && eicadTemp.softwareList ? eicadTemp.softwareList : []
          ).map((item) => {
            const fileInfo =
              item.pathUrlIdList && item.pathUrlIdList.length > 0
                ? item.pathUrlIdList[0]
                : null;
            return {
              btnName: "下载 " + item.name,
              btnId: item.id,
              fileId: fileInfo ? fileInfo.id : "",
              fileTitle: fileInfo ? fileInfo.fileTitle : "",
              filePath: fileInfo ? fileInfo.path : "",
              fileSuffix: fileInfo ? fileInfo.suffix : "",
            };
          });
          this.vrRoadBtnList = (
            vrroadTemp && vrroadTemp.softwareList ? vrroadTemp.softwareList : []
          ).map((item) => {
            const fileInfo =
              item.pathUrlIdList && item.pathUrlIdList.length > 0
                ? item.pathUrlIdList[0]
                : null;
            return {
              // btnName: item.name,
              btnName: "下载客户端",
              btnId: item.id,
              fileId: fileInfo ? fileInfo.id : "",
              fileTitle: fileInfo ? fileInfo.fileTitle : "",
              filePath: fileInfo ? fileInfo.path : "",
              fileSuffix: fileInfo ? fileInfo.suffix : "",
            };
          });
          this.report3DBtnList = (
            report3dTemp && report3dTemp.softwareList
              ? report3dTemp.softwareList
              : []
          ).map((item) => {
            const fileInfo =
              item.pathUrlIdList && item.pathUrlIdList.length > 0
                ? item.pathUrlIdList[0]
                : null;
            return {
              // btnName: item.name,
              btnName: "下载客户端",
              btnId: item.id,
              fileId: fileInfo ? fileInfo.id : "",
              fileTitle: fileInfo ? fileInfo.fileTitle : "",
              filePath: fileInfo ? fileInfo.path : "",
              fileSuffix: fileInfo ? fileInfo.suffix : "",
            };
          });

          // 查找出已启用的视频数据和进阶技巧数据
          let temp1 = (
            airoadTemp && airoadTemp.collegeVideoList
              ? airoadTemp.collegeVideoList
              : []
          ).filter((item) => item.startupStatus === "2");
          this.aiRoadVideoList = temp1.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });
          this.aiRoadSkillList = (
            airoadTemp && airoadTemp.informationManageList
              ? airoadTemp.informationManageList
              : []
          ).map((item) => {
            let ext1Obj = JSON.parse(item.ext1);
            const coverUrl =
              item.coverUrlIdList.length > 0 ? item.coverUrlIdList[0].path : "";
            return {
              ...item,
              category: ext1Obj.categorySelects,
              coverUrl: coverUrl,
            };
          });

          let temp2 = (
            eicadTemp && eicadTemp.collegeVideoList
              ? eicadTemp.collegeVideoList
              : []
          ).filter((item) => item.startupStatus === "2");
          this.eiCadVideoList = temp2.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });
          this.eiCadSkillList = (
            eicadTemp && eicadTemp.informationManageList
              ? eicadTemp.informationManageList
              : []
          ).map((item) => {
            let ext1Obj = JSON.parse(item.ext1);
            const coverUrl =
              item.coverUrlIdList.length > 0 ? item.coverUrlIdList[0].path : "";
            return {
              ...item,
              category: ext1Obj.categorySelects,
              coverUrl: coverUrl,
            };
          });

          let temp3 = (
            vrroadTemp && vrroadTemp.collegeVideoList
              ? vrroadTemp.collegeVideoList
              : []
          ).filter((item) => item.startupStatus === "2");
          this.vrRoadVideoList = temp3.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });
          this.vrRoadSkillList = (
            vrroadTemp && vrroadTemp.informationManageList
              ? vrroadTemp.informationManageList
              : []
          ).map((item) => {
            let ext1Obj = JSON.parse(item.ext1);
            const coverUrl =
              item.coverUrlIdList.length > 0 ? item.coverUrlIdList[0].path : "";
            return {
              ...item,
              category: ext1Obj.categorySelects,
              coverUrl: coverUrl,
            };
          });

          let temp4 = (
            report3dTemp && report3dTemp.collegeVideoList
              ? report3dTemp.collegeVideoList
              : []
          ).filter((item) => item.startupStatus === "2");
          this.report3DVideoList = temp4.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });
          this.report3DSkillList = (
            report3dTemp && report3dTemp.informationManageList
              ? report3dTemp.informationManageList
              : []
          ).map((item) => {
            let ext1Obj = JSON.parse(item.ext1);
            const coverUrl =
              item.coverUrlIdList.length > 0 ? item.coverUrlIdList[0].path : "";
            return {
              ...item,
              category: ext1Obj.categorySelects,
              coverUrl: coverUrl,
            };
          });

          console.log("this.aiRoadVideoList", this.aiRoadVideoList);
          console.log("this.aiRoadSkillList", this.aiRoadSkillList);
          console.log("this.aiRoadBtnList", this.aiRoadBtnList);
          console.log("this.eiCadVideoList", this.eiCadVideoList);
          console.log("this.eiCadSkillList", this.eiCadSkillList);
          console.log("this.eiCadBtnList", this.eiCadBtnList);
          console.log("this.vrRoadVideoList", this.vrRoadVideoList);
          console.log("this.vrRoadSkillList", this.vrRoadSkillList);
          console.log("this.vrRoadBtnList", this.vrRoadBtnList);
          console.log("this.report3DVideoList", this.report3DVideoList);
          console.log("this.report3DSkillList", this.report3DSkillList);
          console.log("this.report3DBtnList", this.report3DBtnList);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.academy-container {
  width: 100%;
  .academy-hd {
    width: 100%;
    height: 320px;
    background: url("~@/assets/images/academy/academy-hd_bg.png") no-repeat
      center;
    background-size: cover;
    .academy-hd-wrapper {
      width: 1049px;
      padding-top: 70px;
      margin: 0 auto;
    }
    .academy-hd-title {
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 28px;
      color: #ffffff;
      line-height: 28px;
      font-style: normal;
    }
    .academy-hd-subTitle {
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      opacity: 0.8;
      line-height: 24px;
      font-style: normal;
    }
  }
}
</style>
